import React, { FC } from 'react';
import { classNames } from '../utils/classNames';
import { LinkButtonBaseProps } from './LinkButton';

interface ExternalLinkButtonProps extends LinkButtonBaseProps {
  readonly href: string;
}

export const ExternalLinkButton: FC<ExternalLinkButtonProps> = ({
  id,
  children,
  block,
  outline,
  color = 'primary',
  className = '',
  disabled,
  href,
}) => {
  const btnOutlineColor = color ? `btn${outline ? '-outline' : ''}-${color}` : '';

  return (
    <a
      className={classNames(
        { 'd-block': block, 'w-100': block, disabled },
        `btn ${btnOutlineColor}`,
        className,
      )}
      href={href}
      id={id}
      rel="noopener noreferrer"
      target="_blank"
    >
      {children}
    </a>
  );
};
